import React from "react";
import { statusColor, statusLabel } from "@/lib/constants";

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2.5 py-1 border font-mono text-[10px] uppercase tracking-wider ${statusColor(
      status,
    )}`}
  >
    {statusLabel(status)}
  </span>
);
